import { render } from "./MWFooter.vue?vue&type=template&id=86c5f4d2&scoped=true"
import script from "./MWFooter.vue?vue&type=script&lang=js"
export * from "./MWFooter.vue?vue&type=script&lang=js"

import "./MWFooter.vue?vue&type=style&index=0&id=86c5f4d2&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-86c5f4d2"]])

export default __exports__